<section class="content-header">
  <div class="container-fluid">
    <div class="row mb-2">
      <div class="col-sm-6">
        <h1>Promptlar</h1>
      </div>
      <div class="col-sm-6">
        <div class="float-right">
          <button class="btn btn-primary" (click)="openCreateModal()">
            <i class="fas fa-plus"></i> Yeni Prompt
          </button>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="content">
  <div class="container-fluid">
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col-md-6">
            <div class="input-group">
              <input type="text"
                     class="form-control"
                     placeholder="Prompt ara..."
                     [(ngModel)]="searchTerm">
              <div class="input-group-append">
                <span class="input-group-text"><i class="fas fa-search"></i></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card-body">
        <div *ngIf="loading" class="text-center">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Yükleniyor...</span>
          </div>
        </div>

        <div *ngIf="!loading && filteredPrompts.length === 0" class="alert alert-info">
          Henüz prompt bulunmamaktadır.
        </div>

        <div *ngIf="!loading && filteredPrompts.length > 0" class="table-responsive">
          <table class="table table-bordered table-hover">
            <thead>
              <tr>
                <th style="width: 50px">#</th>
                <th>Ad</th>
                <th>System Prompt</th>
                <th>User Prompt</th>
                <th style="width: 120px">İşlemler</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let prompt of filteredPrompts; let i = index">
                <td>{{ i + 1 }}</td>
                <td><strong>{{ prompt.name }}</strong></td>
                <td>
                  <small class="text-muted">{{ prompt.systemPrompt | slice:0:100 }}{{ prompt.systemPrompt?.length > 100 ? '...' : '' }}</small>
                </td>
                <td>
                  <small class="text-muted">{{ prompt.userPrompt | slice:0:100 }}{{ prompt.userPrompt?.length > 100 ? '...' : '' }}</small>
                </td>
                <td>
                  <button class="btn btn-sm btn-info mr-1"
                          (click)="openEditModal(prompt)"
                          title="Düzenle">
                    <i class="fas fa-edit"></i>
                  </button>
                  <button class="btn btn-sm btn-danger"
                          (click)="deletePrompt(prompt)"
                          title="Sil">
                    <i class="fas fa-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</section>
